module.exports = __webpack_public_path__ + "media/customizations/default/chat-bubble-e3af482ab42a1c60301a7b2888f49087.png";